import React from 'react'

import { LoadingPlaceholder, WorkspaceLogo } from '@sketch/components'
import { AnnotationCommentsList } from '@sketch/modules-common'
import {
  CommentNotificationFragment,
  MentionNotificationFragment,
} from '@sketch/gql-types'

import {
  AnnotationCard,
  Breadcrumb,
  BreadcrumbDocumentIcon,
  BreadcrumbItem,
  BreadcrumbLabel,
  BreadcrumbSeparator,
  CanvasImage,
  CanvasImageWrapper,
  Card,
} from './CommentMentionPreview.styles'

interface CommentMentionPreviewProps {
  notification: CommentNotificationFragment | MentionNotificationFragment
}

export const CommentMentionPreview = ({
  notification,
}: CommentMentionPreviewProps) => {
  const { share, comment, user, previews } = notification
  const annotationIdentifier = notification.comment?.annotation.identifier

  if (!share || !comment || !user || !annotationIdentifier) return null

  const previewUrl = previews[0]?.url ?? undefined

  return (
    <Card>
      <Breadcrumb>
        <WorkspaceLogo
          size="24px"
          workspaceName={notification.workspace?.name}
          src={notification.workspace?.avatar?.small}
        />
        <BreadcrumbItem>
          <BreadcrumbLabel>{share.workspace.name}</BreadcrumbLabel>
          <BreadcrumbSeparator>/</BreadcrumbSeparator>
        </BreadcrumbItem>

        <BreadcrumbItem>
          <BreadcrumbDocumentIcon aria-hidden />
          <BreadcrumbLabel>{share.name}</BreadcrumbLabel>
        </BreadcrumbItem>
      </Breadcrumb>

      <CanvasImageWrapper>
        <CanvasImage
          src={previewUrl}
          alt={previewUrl ? `Preview of ${share.name}` : ''}
          objectFit="cover"
          width="100%"
          height="100%"
          loadingPlaceholder={<LoadingPlaceholder size="64px" />}
        />
      </CanvasImageWrapper>

      <AnnotationCard>
        <AnnotationCommentsList
          annotationIdentifier={annotationIdentifier}
          isViewingLatestVersion
          commentType="FIXED"
        />
      </AnnotationCard>
    </Card>
  )
}
